import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Star } from "lucide-react";

export default function LeaveReview() {
  const { code } = useParams();
  const nav = useNavigate();
  const [rating, setRating] = useState(5);
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    setSubmitting(true);
    try {
      await api.post("/reviews", { customer_name: name, rating, text, booking_code: code });
      toast.success("Thank you! Your review is awaiting approval.");
      setTimeout(() => nav("/"), 1200);
    } catch { toast.error("Could not submit review"); }
    setSubmitting(false);
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 md:py-24">
      <div className="overline">Leave a review</div>
      <h1 className="font-serif-display text-4xl md:text-5xl mt-3">Tell us about your experience.</h1>
      <p className="mt-4 text-[#4A4A4A]">Booking: <span className="font-mono">{code}</span></p>
      <div className="mt-10 space-y-6">
        <div>
          <label className="overline">Your rating</label>
          <div className="flex gap-2 mt-3">
            {[1,2,3,4,5].map(n => (
              <button key={n} onClick={() => setRating(n)}>
                <Star size={28} className={n <= rating ? "fill-[#0F172A] text-[#0F172A]" : "text-[#E2E8F0]"}/>
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="overline">Your name</label>
          <input value={name} onChange={(e) => setName(e.target.value)}
                 className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-3 outline-none"/>
        </div>
        <div>
          <label className="overline">Your review</label>
          <textarea rows={5} value={text} onChange={(e) => setText(e.target.value)}
                    className="mt-2 w-full border border-[#E2E8F0] focus:border-[#0F172A] bg-white p-4 outline-none"/>
        </div>
        <button onClick={submit} disabled={!name || !text || submitting}
                className="px-8 py-3 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F] disabled:opacity-30">
          {submitting ? "Submitting..." : "Submit Review"}
        </button>
      </div>
    </div>
  );
}
